import baseAPI from "@/http";

const router = "api/geral/propriedade";

export const propriedadeAPI = {
  create: propriedade => baseAPI.post(router, propriedade),
  update: propriedade => baseAPI.put(router, propriedade),
  get: id => baseAPI.get(`${router}/${id}`),
  list: () => baseAPI.get(`${router}`),
  listByUsuario: () => baseAPI.get(`${router}/usuario`),
  cadastrarImagens: propriedade =>
    baseAPI.post(router + "/adicionar-imagens", propriedade)
};
